<template>
  <BaseOverlay
    v-if="isVisible && firstHub && isUserAdmin"
    :close-btn="true"
    @close="close"
  >
    <div class="clara-banner">
      <div class="clara-banner__content">
        <img
          src="/img/clara-ai/bi_magic.svg"
          alt="Clara AI"
          class="clara-banner__icon"
        >
        <h2 class="clara-banner__title">{{ $t('adminTitles.claraAI.banner.title') }}</h2>
        <p class="clara-banner__description body-text">
          {{ $t('adminTitles.claraAI.banner.description') }}
        </p>
        <p class="clara-banner__highlight body-text">
          {{ $t('adminTitles.claraAI.banner.ticketsResolved') }}
        </p>
        <BaseButton
          class="clara-banner__button"
          @click="explore"
        >
          {{ $t('adminTitles.claraAI.banner.explore') }}
        </BaseButton>
      </div>
    </div>
  </BaseOverlay>
</template>

<script>
import {mapGetters} from 'vuex';
import BaseOverlay from '@/views/RenovaDashboard/components/ui-kit/BaseOverlay';
import BaseButton from '@/views/RenovaDashboard/components/ui-kit/Buttons/BaseButton';
import {USER_ROLES} from '@/store/modules/user';

export default {
  name: 'ClaraAIPopup',
  components: {
    BaseButton,
    BaseOverlay,
  },
  computed: {
    ...mapGetters(['firstHub', 'userRole']),
    isUserAdmin() {
      return this.userRole === USER_ROLES.ADMIN;
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  mounted() {
    const isBannerShown = localStorage.getItem('clara_ai_banner_shown');
    if (!isBannerShown) {
      this.isVisible = true;
    }
  },
  methods: {
    close() {
      this.isVisible = false;
      localStorage.setItem('clara_ai_banner_shown', 'true');
    },
    explore() {
      this.close();
      this.$router.push('/admin/clara-ai');
    },
  },
};
</script>

<style lang="scss" scoped>
.clara-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;

  &__content {
    background: #FFFFFF;
    border-radius: 24px;
    padding: 50px 58px;
    width: 440px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.1);
  }

  &__icon {
    width: 64px;
    height: 64px;
    margin-bottom: 5px;
  }

  &__title {
    font-family: 'Gilroy';
    font-weight: 700;
    font-size: 21px;
    line-height: 24px;
    color: #191245;
    margin-bottom: 16px;
  }

  &__description {
    font-family: 'Gilroy', serif;
    margin-bottom: 16px;
  }

  &__highlight {
    font-family: 'Gilroy', serif;
    font-weight: 700;
    margin-bottom: 40px;
  }

  &__button {
    min-width: 140px;
    padding: 12px 32px;
  }
}
</style>
